import { ClickAwayListener } from "@mui/material";
import { type FC, type ReactNode, useState } from "react";
import { type CSSObject } from "styled-components";

import { useTabStatus } from "@/hooks/useTabStatus";
import { ShareIcon } from "@/icons";

import * as S from "./styled";

interface ShareOptionsProps {
  onExperienceShare: (isSingleItem: boolean) => void;
  customIcon?: ReactNode;
  fabButtonStyles?: CSSObject;
  isFullExperienceShare?: boolean;
  isSingleExperienceShare?: boolean;
  label?: string;
  onMediaShare?: (isSingleItem: boolean) => void;
  shareButtonsContainerStyles?: CSSObject;
  shareContainerStyles?: CSSObject;
  shouldShowMultipleShareButtons?: boolean;
}

const ShareOptions: FC<ShareOptionsProps> = ({
  onExperienceShare,
  customIcon,
  fabButtonStyles,
  isFullExperienceShare,
  isSingleExperienceShare,
  label,
  onMediaShare,
  shareButtonsContainerStyles,
  shareContainerStyles,
  shouldShowMultipleShareButtons,
}) => {
  const [showShareButtons, setShowShareButtons] = useState(false);

  const { isTabShare, isTabCollect, isTabCustomize } = useTabStatus();

  const handleExperienceSingleShareClick = () => {
    onExperienceShare(true);
  };

  const handleMediaSingleShareClick = () => {
    onMediaShare?.(true);
  };

  const handleExperienceFullShareClick = () => {
    onExperienceShare(false);
  };

  const handleMediaFullShareClick = () => {
    onMediaShare?.(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setShowShareButtons(false)}>
      <S.ButtonContainer $shareContainerStyles={shareContainerStyles} sx={{ position: "relative" }}>
        <S.ShareFab
          aria-label="Share"
          data-testid="main-share-button"
          size="small"
          onClick={() =>
            shouldShowMultipleShareButtons
              ? setShowShareButtons(!showShareButtons)
              : isTabShare || isTabCollect || isTabCustomize
                ? handleExperienceFullShareClick()
                : isSingleExperienceShare
                  ? handleExperienceSingleShareClick()
                  : handleMediaSingleShareClick()
          }
          $fabButtonStyles={fabButtonStyles}
        >
          {customIcon ? customIcon : <ShareIcon />}
          {label && <S.ShareLabel>{label}</S.ShareLabel>}
        </S.ShareFab>

        {shouldShowMultipleShareButtons && showShareButtons && (
          <S.ShareButtonsContainer $shareButtonsContainerStyles={shareButtonsContainerStyles}>
            <S.ShareButton
              onClick={isFullExperienceShare ? handleExperienceFullShareClick : handleMediaFullShareClick}
              data-testid="full-share"
            >
              {isFullExperienceShare ? "Full Experience" : "Full Collection"}
            </S.ShareButton>
            <S.ShareButton
              onClick={isSingleExperienceShare ? handleExperienceSingleShareClick : handleMediaSingleShareClick}
              data-testid="single-asset-share"
            >
              This Asset
            </S.ShareButton>
          </S.ShareButtonsContainer>
        )}
      </S.ButtonContainer>
    </ClickAwayListener>
  );
};

export default ShareOptions;
